export default class TagFormController {
  constructor($element, $scope) {
    'ngInject';

    this.$element = $element;
    this.$scope = $scope;
  }

  $postLink() {
    this.$element.bind('keyup', (event) => {
      const key = event.which;

      if (key === 9 || key === 13) {
        event.preventDefault();
        this.$scope.$apply('$ctrl.handleCreate($ctrl.newTag)');
      }
    });
  }

  handleCreate(tag) {
    if (tag) {
      this.tags.push(tag);
      this.adding = false;
      this.onCreate && this.onCreate({tag: tag});
      this.newTag = '';
    }
  }

  handleDelete(tag) {
    const tagIndex = this.tags.indexOf(tag);
    if (tagIndex > -1) {
      this.tags.splice(tagIndex, 1);
    }
    this.onDelete && this.onDelete({tag: tag});
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/components/tag-form/tag-form.controller.js